import Grid from '@material-ui/core/Grid';
import { Brand } from '@Praia-Health/spi-common-utils/types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import checkboxControl, { privacyPolicyCheckboxLabel } from '../../../controls/CheckboxControl';
import cityControl from '../../../controls/CityControl';
import dateOfBirthControl from '../../../controls/DateOfBirthControl';
import firstNameControl from '../../../controls/FirstNameControl';
import genderControl from '../../../controls/GenderControl';
import last4SsnControl from '../../../controls/Last4SsnControl';
import lastNameControl from '../../../controls/LastNameControl';
import MobilePhoneControl from '../../../controls/MobilePhoneControl';
import stateControl from '../../../controls/StateControl';
import streetAddressControl from '../../../controls/StreetAddressControl';
import zipCodeControl from '../../../controls/ZipCodeControl';

export type CollectDemographicsFormProps = {
    control: any;
    errors: any;
    setTermsAccepted: (terms: boolean) => void;
    brand: Brand;
    phoneNumber: string;
};

function CollectDemographicsForm(props: CollectDemographicsFormProps) {
    const { t } = useTranslation();
    const infoComponent = (
        <>{t('To access your medical records, we need to confirm your identity. Confirmation is done with a secure 3rd party service called Prove, Inc.')}</>
    );

    return (
        <Grid container spacing={2} direction='row' justify='space-evenly'>
            <Grid container justify='center' alignContent='flex-end' alignItems='flex-end'>
                <Grid item xs={9} sm={3}>
                    {firstNameControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={9} sm={3}>
                    {lastNameControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={9} sm={3}>
                    {genderControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={9} sm={3}>
                    {dateOfBirthControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={9} sm={3}>
                    <MobilePhoneControl control={props.control} errors={props.errors} labelOverride={'Phone number'} shrink={true} phoneNumber={props.phoneNumber} />
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={9} sm={3}>
                    {last4SsnControl(props.control, props.errors, true, true)}
                </Grid>
                <Grid item xs={9} sm={11}>
                    {streetAddressControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={6} sm={3}>
                    {cityControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={3} sm={3}>
                    {stateControl(props.control, props.errors, undefined)}
                </Grid>
                <Grid item xs={false} sm={1} />
                <Grid item xs={9} sm={3}>
                    {zipCodeControl(props.control, props.errors, false, undefined)}
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12}></Grid>
            <Grid container justify='center' spacing={2}>
                <Grid item xs={12} sm={9}>
                    {checkboxControl(privacyPolicyCheckboxLabel(props.brand), props.setTermsAccepted)}
                </Grid>
                <Grid item xs={12} sm={9} className='noteText'>
                    {infoComponent}
                </Grid>
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}></Grid>
        </Grid>
    );
}

export default CollectDemographicsForm;
